

























































































































































import { Component, Vue } from 'vue-property-decorator';
import CommonInput from "@/components/common/CommonInput.vue";
import TimeInput from "@/components/common/TimeInput.vue";
import CommonTextarea from "@/components/common/CommonTextarea.vue";
import SecureInput from "@/components/common/SecureInput.vue";
import EventDate from "@/components/form/EventDate.vue";
import InputRules from "@/utils/InputRules";
import CommonButton from "@/components/common/CommonButton.vue";
import TimeZoneInput from "@/components/form/TimeZoneInput.vue";
import MapInput from "@/components/form/MapInput.vue";
import {EventLesson} from "@/models/Event/EventLesson";
import LessonsInput from "@/components/form/LessonsInput.vue";

@Component({
  components: {
    LessonsInput,
    MapInput,
    TimeZoneInput,
    CommonButton,
    CommonInput,
    EventDate,
    TimeInput,
    CommonTextarea,
    SecureInput
  },
})
export default class CreateEvent extends Vue {
  private formValid:boolean = false;
  private color:string = 'indigo lighten-5';
  private formData = {
    typeId: 2,
    name: '',
    cost: 0,
    promoCode: '',
    mediaCategory: '',
    category: 0,
    media: '',
    mediaId: 0,
    date: '',
    time: '',
    timeZone: '',
    timezoneId: 0,
    commentsFromLeader: '',
    password: '',
    passwordConfirm: '',
    locationName: '',
    locationX: null,
    locationY: null,
    demo: '',
    lessonsTitle: '',
    lessons: [{title: '', videoLink: ''}],
    userId: '',
  };
  private formErrors = {
    name: '',
    cost: '',
    promoCode: '',
    mediaCategory: '',
    media: '',
    date: '',
    time: '',
    timeZone: '',
    commentsFromLeader: '',
    password: '',
    passwordConfirm: '',
    locationName: '',
    demo: '',
    lessons: ''
  };

  get rules() {
    return {
      requiredRules: [
        (v: any) => InputRules.required(v) || this.$t('default.form.inputs.required_error'),
      ],
      passwordConfirm: [
        (v: any) => InputRules.required(v) || this.$t('login_page.form.inputs.password_confirm.required_error'),
        (v: any) =>  v === this.formData.password  || this.$t('signup_page.form.inputs.password_confirm.match_error'),
      ]
    }
  }

  private isLogging = false;

  created() {
    this.formData.cost = 0;
    //TODO Get Event by class_id
    this.formData.lessons = [
      {title: 'Lesson 1', videoLink: 'http://test.com'},
      {title: 'Lesson 2', videoLink: 'http://test.com'}];
  }

  private handleSubmit() {
    this.isLogging = true;
  }

  private handleChangeTimeZone(zoneId: number) {
    if (zoneId) {
      this.formData.timezoneId = zoneId;
    }
  }

  private handleChangeLocation(location: any) {
    if (location) {
      this.formData.locationName = location.name;
      this.formData.locationX = location.position.lat || null;
      this.formData.locationY = location.position.lng || null;

    } else {
      this.formData.locationName = '';
      this.formData.locationX = null;
      this.formData.locationY = null;
    }
  }

  private handleUpdateLessons(lessons: Array<any>) {
    this.formData.lessons = lessons;
  }
}
